import { Box, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import Affirm from "./affirm"
import { PlanTitle } from "./component"
import Klarna from "./klarna"

const TitleBlock = styled(Box).attrs((props) => ({
  mx: { _: "29px", desktop: "auto" },
  ...props.theme.info.titleBlock,
}))``

const KlarnaAffirm = ({ paymentPrices }) => {
  return (
    <>
      <Box contain mb="120px" textAlign="center">
        <TitleBlock>
          <PlanTitle>Payment Plans</PlanTitle>
          <Typography
            fontSize="22px"
            fontWeight="400"
            lineHeight="33.8px"
            mb={3}
          >
            Made For You
          </Typography>

          <Typography
            lineHeight="20px"
            mx="auto"
            width={{ _: "auto", desktop: "402px" }}
          >
            {sl.config.site_title} has partnered with Affirm and Klarna to offer
            a choice of payment options perfect for you.
          </Typography>
        </TitleBlock>
        <Flex
          flexDirection={{ _: "column", desktop: "row" }}
          justifyContent="center"
        >
          <Affirm paymentPrices={paymentPrices} />
          <Klarna paymentPrices={paymentPrices} />
        </Flex>
      </Box>
    </>
  )
}

KlarnaAffirm.propTypes = {
  paymentPrices: PropTypes.object,
}

export default KlarnaAffirm
